const DefaultErrorMessage = 'Es ist ein Fehler aufgetreten.';

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return DefaultErrorMessage;
}
